import { toRomaji, isKanji } from 'wanakana';

export default class StrHelper {
  static isEmpty(str) {
    return typeof(str) === 'undefined' || !str || str.trim() === ''
  }

  static toInt(str) {
    return Number.parseInt(str, 10)
  }

  static toFloat(str) {
    return parseFloat(str)
  }

  static normalize(str) {
    str = str.toLowerCase()
    return toRomaji(str)
  }

  static isContainKanji(str) {
    for(let i = 0; i < str.length; i++){
      if(isKanji(str[i]))
        return true
    }
    return false
  }
}
